/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_StoreInputs */

const en_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading Store`)
};

const es_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando tienda`)
};

const fr_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la boutique`)
};

const de_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store wird geladen`)
};

const ja_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアを読み込み中`)
};

const zh_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载店铺`)
};

const ar_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري تحميل المتجر`)
};

const id_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat Toko`)
};

const it_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento negozio`)
};

const ru_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка магазина`)
};

const pt_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando loja`)
};

const ko_loading_store = /** @type {(inputs: Loading_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어 로딩 중`)
};

/**
* | output |
* | --- |
* | "Loading Store" |
*
* @param {Loading_StoreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const loading_store = /** @type {((inputs?: Loading_StoreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_StoreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_store(inputs)
	if (locale === "es") return es_loading_store(inputs)
	if (locale === "fr") return fr_loading_store(inputs)
	if (locale === "de") return de_loading_store(inputs)
	if (locale === "ja") return ja_loading_store(inputs)
	if (locale === "zh") return zh_loading_store(inputs)
	if (locale === "ar") return ar_loading_store(inputs)
	if (locale === "id") return id_loading_store(inputs)
	if (locale === "it") return it_loading_store(inputs)
	if (locale === "ru") return ru_loading_store(inputs)
	if (locale === "pt") return pt_loading_store(inputs)
	return ko_loading_store(inputs)
});